"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedListAttributes = exports.ListAttributes = void 0;
var ListAttributes;
(function (ListAttributes) {
    ListAttributes["UNORDERED"] = "UNORDERED";
    ListAttributes["NOSTYLE"] = "NOSTYLE";
    ListAttributes["ORDERED"] = "ORDERED";
})(ListAttributes = exports.ListAttributes || (exports.ListAttributes = {}));
var UnsupportedListAttributes;
(function (UnsupportedListAttributes) {
    UnsupportedListAttributes["MENU"] = "MENU";
    UnsupportedListAttributes["DEFINITION"] = "DEFINTION";
    UnsupportedListAttributes["BOX"] = "BOX";
    UnsupportedListAttributes["BUTTON"] = "BUTTON";
    UnsupportedListAttributes["TOGGLE_BUTTON_GROUP"] = "TOGGLE_BUTTON_GROUP";
})(UnsupportedListAttributes = exports.UnsupportedListAttributes || (exports.UnsupportedListAttributes = {}));
